"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUndefined = void 0;
exports.isUndefined = (value) => value === undefined;
//# sourceMappingURL=is-undefined.js.map